/* ------------------------------------------------------------------ */
/* Marketing ROI Calculator — defaults and calculation logic           */
/* ------------------------------------------------------------------ */

export interface MarketingChannel {
  id: string
  name: string
  annualCost: number
  leadsPerYear: number
}

export interface MarketingRoiResult {
  channels: {
    id: string
    name: string
    annualCost: number
    leadsPerYear: number
    costPerLead: number
  }[]
  totalSpend: number
  totalLeads: number
  avgCostPerLead: number
}

export const DEFAULT_CHANNELS: MarketingChannel[] = [
  { id: "portals", name: "Property portals", annualCost: 12_000, leadsPerYear: 120 },
  { id: "video", name: "Video marketing", annualCost: 3_588, leadsPerYear: 80 },
  { id: "social", name: "Social media", annualCost: 2_400, leadsPerYear: 30 },
  { id: "photography", name: "Photography", annualCost: 6_000, leadsPerYear: 60 },
  { id: "print", name: "Print & brochures", annualCost: 3_600, leadsPerYear: 15 },
  { id: "signage", name: "Signage & boards", annualCost: 2_000, leadsPerYear: 25 },
]

export function calculateMarketingRoi(channels: MarketingChannel[]): MarketingRoiResult {
  const results = channels.map((ch) => ({
    id: ch.id,
    name: ch.name,
    annualCost: ch.annualCost,
    leadsPerYear: ch.leadsPerYear,
    costPerLead: ch.leadsPerYear > 0 ? ch.annualCost / ch.leadsPerYear : 0,
  }))

  const totalSpend = results.reduce((sum, ch) => sum + ch.annualCost, 0)
  const totalLeads = results.reduce((sum, ch) => sum + ch.leadsPerYear, 0)
  const avgCostPerLead = totalLeads > 0 ? totalSpend / totalLeads : 0

  return {
    channels: results.sort((a, b) => a.costPerLead - b.costPerLead),
    totalSpend,
    totalLeads,
    avgCostPerLead: Math.round(avgCostPerLead),
  }
}

export { formatCurrency } from "@/lib/format-currency"
